import React, { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import Select from 'components/Select';
import { ToastError } from 'components/Toaster';
import { SolucoesPerfilUsuarioService } from 'core/http/service/SolucoesPerfilUsuario.service';
import { TipoSolucoesService } from 'core/http/service/TipoSolucoes.service';
import dayjs from 'dayjs';
import Colors from 'enums/Colors';
import TipoSolucoes from 'models/solucoes/TipoSolucoes';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { IoReload } from 'react-icons/io5';
import styled from 'styled-components';

interface ParmsReportSolucao {
    idSolucao: number | null;
    dateInicio?: string | null;
    dateFim?: string | null;
}

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1100px;
        min-height: 320px;
        background-color: #ffffff;
        padding: 40px;
        gap: 2rem;
        margin-bottom: 200px;

        -webkit-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        -moz-box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
        box-shadow: 15px 15px 5px -11px rgba(0, 0, 0, 0.27);
    `,

    Title: styled.h1`
        font-size: 26px;
        font-weight: 700;
        color: ${Colors.Blue};
        text-decoration: underline;
        text-underline-offset: calc(1rem);
    `,

    Content: styled.div`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: 1rem;
        gap: 2rem;
        margin-top: 30px;
    `,

    SubTitle: styled.p`
        font-size: 14px;
        font-weight: 600;
        color: ${Colors.Blue};
        margin-bottom: 10px;
    `,
};

interface ICardReportSolucoes {}

const CardReportSolucoes = ({}: ICardReportSolucoes) => {
    const [loadingSubmit, setLoadingSubmit] = useState<number>(-1);
    const [solucaoSelected, setSolucaoSelected] = useState<any>();
    const [solucoes, setSolucoes] = useState<TipoSolucoes[]>([]);
    const [dataPeriodo, setDataPeriodo] = useState<string[]>([]);

    const serviceTipoSolucoes = new TipoSolucoesService();
    const servicePerfilUsuario = new SolucoesPerfilUsuarioService();

    function cleanParams(params: Record<string, any>) {
        return Object.fromEntries(
            Object.entries(params).filter(([_, value]) => {
                return value !== undefined && value !== null && value !== '';
            })
        );
    }

    const handleRelatorioFad = async () => {
        
        if (!solucaoSelected) {
            return ToastError('Nenhuma solução selecionada!');
        }

        setLoadingSubmit(1);

        try {
            const rawBody: ParmsReportSolucao = {
                idSolucao: solucaoSelected?.value ?? null,
                dateInicio: dataPeriodo.length > 0 ? dataPeriodo[0] : null,
                dateFim: dataPeriodo.length > 0 ? dataPeriodo[1] : null,
            };
    
            const body = cleanParams(rawBody);
    
            const response = await servicePerfilUsuario.getRelatorio(body);
    
            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=UTF-8' });
            const url = window.URL.createObjectURL(blob);
    
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `relatorio-${new Date().toISOString().slice(0, 10)}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
        } catch (error) {
            ToastError("Ocorreu algum erro no servidor!")
            console.log("🚀 ~ handleRelatorioFad ~ error:", error)
            
        }
        setLoadingSubmit(-1);
    };

    const getAllSolucoes = async () => {
        const { data, status } = await serviceTipoSolucoes.getAll();

        if (status === 200) {
            setSolucoes(data);
        }
    };

    const clearFilter = () => {
        setDataPeriodo([]);
        setSolucaoSelected(null);
    };
    useEffect(() => {
        getAllSolucoes();
    }, []);

    return (
        <Styled.Container>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Styled.Title>INTERESSE NAS SOLUÇÕES</Styled.Title>
                <div
                    onClick={clearFilter}
                    style={{
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <IoReload size={24} />
                    Limpar filtro
                </div>
            </div>
            <Styled.Content>
                <div>
                    <Styled.SubTitle>Solução</Styled.SubTitle>
                    <Select
                        style={{ width: '200px' }}
                        placeholder="Selecione"
                        value={solucaoSelected}
                        onSelected={s => setSolucaoSelected(s)}
                        itens={solucoes.map((dados: any) => ({
                            value: dados.id,
                            label: dados.nome,
                        }))}
                    />
                </div>

                <div>
                    <Styled.SubTitle>Período</Styled.SubTitle>
                    <DatePicker.RangePicker
                        size="large"
                        style={{
                            height: 50,
                        }}
                        value={dataPeriodo.length === 2 ? [dayjs(dataPeriodo[0]), dayjs(dataPeriodo[1])] : null}
                        placeholder={['Início', 'Término']}
                        allowEmpty={[false, false]}
                        onChange={(date, dateString) => {
                            setDataPeriodo(dateString);
                        }}
                    />
                </div>
            </Styled.Content>
            <ButtonHomeV2
                disabled={loadingSubmit === 1}
                style={{ color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => {
                    loadingSubmit === -1 && handleRelatorioFad();
                }}
            >
                {loadingSubmit === 1 ? <div className="loaderCreater" /> : 'Gerar relatório'}
            </ButtonHomeV2>
        </Styled.Container>
    );
};

export default CardReportSolucoes;
